export const getItemHtml = (item, isSlide = false) => {
    if (!item)
        return '';
    let image = '';
    const srcsetAttr = item.srcset ? ` srcset="${item.srcset}"` : '';
    image = `
    <img loading="lazy" src="${item.src}"${srcsetAttr} alt="${item.alt}">
  `;
    let details = '';
    if (item.caption) {
        let label = '';
        if (item.label) {
            label = `<div class="lightbox__label">${item.label}</div>`;
        }
        const caption = `<div class="lightbox__caption">${item.caption}</div>`;
        details = `
      <div class="lightbox__details">
          ${label}
          ${caption}
      </div>
    `;
    }
    const slideClass = isSlide ? ' swiper-slide' : '';
    return `
    <div class="lightbox__item${slideClass}">
      <div class="lightbox__image">${image}</div>
      ${details}
    </div>
  `;
};
export const getMainContentHtml = (items) => {
    if (!items)
        return '';
    let content = '';
    if (items.length === 1) {
        content = getItemHtml(items[0]);
    }
    else if (items.length > 0) {
        content = `
      <div class="lightbox__slider swiper">
        <div class="lightbox__items swiper-wrapper">
    `;
        items.forEach((item) => {
            content += getItemHtml(item, true);
        });
        content += `
        </div>
      </div>
    `;
    }
    return content;
};
export const getThumbsHtml = (items) => {
    if (!items)
        return '';
    let html = `
    <div class="lightbox__thumbs">
      <div class="lightbox__thumbs-slider swiper">
        <div class="lightbox__thumbs-items swiper-wrapper">
  `;
    items.forEach((item) => {
        var _a, _b;
        const src = ((_a = item === null || item === void 0 ? void 0 : item.thumb) === null || _a === void 0 ? void 0 : _a.src) || item.src || '';
        const srcset = ((_b = item === null || item === void 0 ? void 0 : item.thumb) === null || _b === void 0 ? void 0 : _b.srcset) || item.srcset || '';
        const srcsetAttr = srcset ? ` srcset="${srcset}"` : '';
        html += `
      <div class="lightbox__thumbs-item swiper-slide">
        <img src="${src}"${srcsetAttr} alt="${item.alt}">
      </div>
    `;
    });
    html += `
        </div>
      </div>
    </div>
  `;
    return html;
};
export const getPrevBtnHtml = () => {
    return `
    <button class="lightbox__prev" type="button" title="Previous">
      <svg width="22" height="64" viewBox="0 0 22 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 1.04326L2.35547 32L22 62.9567L20.3068 64L0 32L20.3068 0L22 1.04326Z"></path>
      </svg>
    </button>
  `;
};
export const getNextBtnHtml = () => {
    return `
    <button class="lightbox__next" type="button" title="Next">
      <svg width="22" height="64" viewBox="0 0 22 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.12046e-08 62.9567L19.6445 32L5.50385e-06 1.04326L1.69321 -1.77528e-06L22 32L1.69321 64L9.12046e-08 62.9567Z"></path>
      </svg>
    </button>
  `;
};
export const getWidgetHtml = (items, options = {}) => {
    if (!items)
        return '';
    const isGallery = items.length > 1;
    const showThumbs = options.thumbnails;
    const prevBtn = isGallery ? getPrevBtnHtml() : '';
    const nextBtn = isGallery ? getNextBtnHtml() : '';
    const thumbs = isGallery && showThumbs ? getThumbsHtml(items) : '';
    const content = getMainContentHtml(items);
    const html = `
    ${prevBtn}
    <div class="lightbox__main">
      ${content}
      ${thumbs}
    </div>
    ${nextBtn}
    <button class="lightbox__close-btn" type="button" title="Close" data-lightbox-close></button>
  `;
    return html;
};
